/**
 * Marks a post-checkout destination with `welcome=true` — the flag `Home`
 * reads to show the download banner — without disturbing whatever else the
 * destination already carries.
 *
 * Existing query params are preserved and an existing `welcome` is
 * overwritten rather than duplicated. Relative destinations — and absolute
 * ones that resolve to the current origin — are returned relative so the
 * locale-aware router can prefix the active locale on navigation. Cross-origin
 * URLs (including `hallow:` deep links) are returned whole, since the router
 * can't locale-prefix another host.
 */
export const withWelcomeParam = (destination: string): string => {
  try {
    const url = new URL(destination, window.location.href);
    url.searchParams.set("welcome", "true");
    if (url.origin === window.location.origin)
      return `${url.pathname}${url.search}${url.hash}`;
    return url.toString();
  } catch {
    return destination;
  }
};
